import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { TextHighlighted } from '@playbookux/playbook-web-core';
import {
  ContainerTranscript,
} from './styles';

import EditableInput from '../../../editable-input';

import extractTranscriptText from '../../../../utils/extract-transcript-text';

const Transcript = (props) => {
  const {
    answer,
    onSubmit,
    onStartEditing,
  } = props;

  const [value, setValue] = useState('');
  const [initialValue, setInitialValue] = useState('');
  const [readOnly, setReadOnly] = useState(true);

  useEffect(() => {
    if (!value && !initialValue) {
      const allTranscripts = extractTranscriptText(answer.transcript);
      setValue(answer.transcriptText || (allTranscripts || 'Transcript not available'));
      setInitialValue(answer.transcriptText || (allTranscripts || 'Transcript not available'));
    }
  }, [value, initialValue, answer.transcript, answer.transcriptText]);

  useEffect(() => {
    onStartEditing(!readOnly);
  }, [readOnly, onStartEditing]);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleEdit = () => {
    setReadOnly(false);
  };

  const handleCancel = () => {
    setValue(initialValue);
    setReadOnly(true);
  };

  const handleSubmit = () => {
    setReadOnly(true);
    onSubmit(value);
  };

  return (
    <ContainerTranscript>
      <EditableInput
        value={value}
        onChange={handleChange}
        onSubmit={handleSubmit}
        readOnly={readOnly}
        onCancel={handleCancel}
        onFocus={(input) => !readOnly && input.current && input.current.focus()}
        hasEditButton
        onClickEdit={handleEdit}
        readOnlyValue={(
          <TextHighlighted
            tagHighlights={answer.tagHighlights}
            text={value}
          />
        )}
      />
    </ContainerTranscript>
  );
};

Transcript.propTypes = {
  answer: PropTypes.shape({
    id: PropTypes.string.isRequired,
    transcriptText: PropTypes.string,
    transcript: PropTypes.shape({
      results: PropTypes.array,
    }),
    tagHighlights: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        charStart: PropTypes.number.isRequired,
        charEnd: PropTypes.number.isRequired,
        tag: PropTypes.shape({
          id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          count: PropTypes.number.isRequired,
          tagGroup: PropTypes.shape({
            id: PropTypes.string.isRequired,
            color: PropTypes.string.isRequired,
          }),
        }).isRequired,
      }),
    ),
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onStartEditing: PropTypes.func.isRequired,
};

export default Transcript;
